class Modal {
  constructor({ trigger, container, title, text, immediate, className = 'modal--default' }) {
    this.trigger = trigger;
    this.container = container || document.body;
    this.title = title;
    this.text = text;
    this.className = typeof className === 'string' ? [className]: className;

    if(!immediate) {
      trigger.addEventListener('click', (function () {
        this.createModal();
      }).bind(this));
    } else {
      this.createModal();
    }
  }

  destroyModal() {
    if(this.modal) {
      this.modal.remove();
      document.querySelector('html').classList.remove('scroll-locked');
    }
  }

  createModal() {
    this.modal = document.createElement('div');
    this.modal.classList.add('modal', ...this.className);
    this.modal.addEventListener('click', (function () {
      this.destroyModal();
    }).bind(this));

    const modal_body = document.createElement('div');
    modal_body.classList.add('modal__body');
    modal_body.addEventListener('click', (function (e) {
      e.stopPropagation();
    }).bind(this));

    const modal_close = document.createElement('button');
    modal_close.type = 'button';
    modal_close.classList.add('modal__close');
    modal_close.textContent = '✕';
    modal_close.addEventListener('click', (function () {
      this.destroyModal();
    }).bind(this));

    const modal_title = document.createElement('div');
    modal_title.classList.add('modal__title');
    modal_title.innerHTML = this.title;

    const modal_text = document.createElement('div');
    modal_text.classList.add('modal__text');
    modal_text.innerHTML = this.text;

    modal_body.append(modal_close, modal_title, modal_text);
    this.modal.append(modal_body);
    this.container.append(this.modal);
    document.querySelector('html').classList.add('scroll-locked');
  }
}

window.Modal = Modal;